<template>
  <component :is="localBid === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="localBid === undefined">
      <h4 class="alert-heading">Erreur de récupération des données du Projet</h4>
      <div class="alert-body">
        Pas de projet trouvé sur cet identifiant. Vérifiez
        <b-link class="alert-link" :to="{ name: 'apps-bids-list' }">
          la liste des Offres
        </b-link>
        pour d'autres Offres.
      </div>
    </b-alert>

    <b-tabs v-if="localBid" pills>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">Générale</span>
        </template>
        <bid-edit-tab-account  :bid-data="localBid" class="mt-2 pt-75" />
      </b-tab>

      <!-- Tab: State -->
      <b-tab>
        <template #title>
          <feather-icon icon="AlertTriangleIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">États</span>
        </template>
        <bid-edit-tab-state :bid-data="localBid" @stateUpdated="getBid" class="mt-2 pt-75" />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
/* eslint-disable */
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import BidEditTabAccount from "./BidEditTabAccount.vue";
import BidEditTabState from "./BidEditTabState.vue";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    BidEditTabAccount,
    BidEditTabState,
  },
  setup() {
    const localBid = ref(null);
    
    const getBid = () => {
      store
        .dispatch("bid/fetchBid", { id: router?.currentRoute.params.id })
        .then((response) => {
          localBid.value = response;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            localBid.value = undefined;
          }
        });
    }

    getBid()

    return {
      localBid,
      getBid,
    };
  },
};
</script>
